import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {StyledTeamsTabContainer} from './StyledTeamsTab';
import TableFilters from '../../tabComponents/TableFilters';
import NoSearchResults from '../../../../NoSearchResults';
import Table from '../../../../Table';


const TeamsTab = ({
  columns = [],
  data = [],
  filtersRightSideContent,
  onFilter,
  tableProps,
  ...rest
}) => {
  const [query, setQuery] = useState({
    search: ''
  });
  const [emptyDetails, setEmptyDetails] = useState({
    text: '',
    enabled: false
  });

  const handleOnFilter = (filterParams) => {
    setQuery({...query, ...filterParams});
    onFilter?.(filterParams);
  }

  useEffect(() => {
    const isEmptyList = data.length === 0;
    const search = query?.search || '';
    if (search !== '' && isEmptyList) {
      setEmptyDetails({
        text: search,
        enabled: true
      });
    } else if (emptyDetails.enabled && !isEmptyList) {
      setEmptyDetails({...emptyDetails, enabled: false});
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <StyledTeamsTabContainer
      {...rest}
      size='large'
      direction='vertical'
    >
      <TableFilters
        onFilter={handleOnFilter}
        rightSideContent={filtersRightSideContent}
      />
      {emptyDetails.enabled ? (
        <NoSearchResults
          spinning={tableProps?.loading}
          value={emptyDetails.text}
        />
      ) : (
        <Table
          columns={columns}
          dataSource={data}
          rowKey='email'
          {...tableProps}
        />
      )}
    </StyledTeamsTabContainer>
  );
}

TeamsTab.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  filtersRightSideContent: PropTypes.any,
  onFilter: PropTypes.func,
  tableProps: PropTypes.object
}

export default TeamsTab;
